import type { VisualModule, VisualSample } from './types';

type Dot = { x:number; y:number; age:number; speed:number };

export class TrailVisual implements VisualModule {
  protected left: Dot[] = [];
  protected right: Dot[] = [];
  constructor(protected maxLength = 54) {}

  draw(ctx: CanvasRenderingContext2D, w: number, h: number, s: VisualSample) {
    if (!s.frozen) {
      if (s.left) this.left.push({ x:s.left.x*w, y:s.left.y*h, age:1, speed:s.movement.leftHandSpeed });
      if (s.right) this.right.push({ x:s.right.x*w, y:s.right.y*h, age:1, speed:s.movement.rightHandSpeed });
    }
    const limit = s.reducedMotion ? Math.floor(this.maxLength*.45) : this.maxLength;
    this.left = this.left.slice(-limit); this.right = this.right.slice(-limit);
    this.paint(ctx, this.left, '#65ecff', s.movement.gestureScale);
    this.paint(ctx, this.right, '#ff63b8', s.movement.gestureScale);
  }

  protected paint(ctx: CanvasRenderingContext2D, dots: Dot[], color: string, scale: number) {
    if (dots.length < 2) return;
    ctx.save(); ctx.lineCap='round'; ctx.lineJoin='round';
    for (let i=1;i<dots.length;i++) {
      const a=dots[i-1], b=dots[i];
      ctx.beginPath(); ctx.moveTo(a.x,a.y); ctx.lineTo(b.x,b.y);
      ctx.globalAlpha=(i/dots.length)*.88;
      ctx.strokeStyle=color; ctx.shadowColor=color; ctx.shadowBlur=12+18*b.speed;
      ctx.lineWidth=4+18*b.speed+9*scale; ctx.stroke();
    }
    ctx.restore();
  }
  clear(){ this.left=[]; this.right=[]; }
}
